import { render, staticRenderFns } from "./TicketEditTabConversation.vue?vue&type=template&id=61575e9e"
import script from "./TicketEditTabConversation.vue?vue&type=script&lang=js"
export * from "./TicketEditTabConversation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports